import React, { createContext, useContext, useEffect, useState } from 'react';
export const EnvConfigContext = createContext({});
EnvConfigContext.displayName = 'env-config-context';
export const useEnvConfigContext = () => {
    return useContext(EnvConfigContext);
};
export const EnvConfigContextComponent = ({ envConfigService, envConfigKeys, children, defaultEnvConfig, canThrowError }) => {
    const [envConfig, setEnvConfig] = useState(defaultEnvConfig);
    const [error, setError] = useState();
    if (error) {
        throw error;
    }
    useEffect(() => {
        const getEnvConfig = async () => {
            try {
                const env = await envConfigKeys.reduce(async (configurationsPromise, envConfigKey) => {
                    const configurations = await configurationsPromise;
                    const configuration = await envConfigService.getConfiguration(envConfigKey);
                    return {
                        ...configurations,
                        ...configuration
                    };
                }, Promise.resolve({}));
                if (typeof env === 'object' && Object.keys(env).length) {
                    setEnvConfig(env);
                }
            }
            catch (err) {
                if (canThrowError) {
                    setError(new Error());
                }
            }
        };
        getEnvConfig();
    }, [envConfigKeys, envConfigService, canThrowError]);
    return (React.createElement(EnvConfigContext.Provider, { value: envConfig }, children));
};
export default EnvConfigContextComponent;
//# sourceMappingURL=index.js.map